/**
 * FAQ category helpers.
 *
 * Real categories live in CMS (`faq-categories` collection) with localized
 * name + description; consumers fetch them via `getFaqCategories(locale)` in
 * `lib/cms-server.ts`. The only structural data here is the virtual
 * `most-popular` category, which is NOT a CMS row — it's an overlay built
 * from FAQ items flagged `featured: true`. We synthesize it as a
 * `CmsFaqCategory`-shaped object with translated copy so callers can prepend
 * it to the CMS list and treat both uniformly.
 */

import type { CmsFaqCategory } from "@/lib/cms"
import { faqKeys } from "@/i18n/faq-keys"

export const POPULAR_SLUG = "most-popular"

/**
 * Build the synthesized "Most popular" category. The name + description go
 * through next-intl in callers — pass the namespaced `t` from the FAQ
 * namespace and this returns a full `CmsFaqCategory` shape.
 */
export function makeMostPopularCategory(
  t: (key: string) => string
): CmsFaqCategory {
  return {
    id: POPULAR_SLUG,
    slug: POPULAR_SLUG,
    name: t(faqKeys.catMostPopular),
    description: t("catMostPopularDesc"),
    order: -1,
  }
}
